<template>
  <div class="addTokenVariablePopup">
    <div class="tokenVariableCard">
      <div class="tokenHeader">
        <h6 class="tokenTitle">Add missing information</h6>
        <i class="material-icons closeTokenPopup" @click="closePopup">close</i>
      </div>
      <div class="tokenBody">
        <h6 class="inputTokenTitle">Personal Information</h6>
        <div class="tokenInputBody">
          <div
            class="tokenInputWrap"
            v-for="item in tokenListObj"
            :key="item.key"
          >
            <input
              type="text"
              v-model="tokenObj[item.key]"
              class="inputText"
              :placeholder="getPlaceHolderLabel(item)"
              required
            />
            <!-- <span class="errMsg" v-cloak v-show="validInputBox(item.key)"
              >{{ item.text }} is required</span
            > -->
          </div>
        </div>
        <V-Button
          :type="'button'"
          :className="'tokenVariableSubmitBtn'"
          :text="'Submit'"
          :callback="addTokenAndScheduleSequence"
        />
      </div>
    </div>
    <div class="tokenVariableOverlay"></div>
  </div>
</template>

<script>
import Button from '@/components/Button'
import { TOKENS_VARIABLE } from '@/assets/util/constants/constants'
import shareFunction from '@/assets/util/functions'

export default {
  name: 'Add-Token-Variable-Popup',
  props: ['tokenList', 'seqId'],
  data: function() {
    return {
      tokenObj: {},
      tokenListObj: [],
      tokenObjErrValidate: {}
    }
  },
  components: {
    'V-Button': Button
  },
  computed: {
    customFields() {
      return this.$store.state.salesgear.customFields
    }
  },
  methods: {
    createInputTokenForm() {
      const that = this
      let defaultTokenListObj = TOKENS_VARIABLE
      if (that.tokenList && that.tokenList.length > 0) {
        defaultTokenListObj.map(item => {
          if (that.tokenListObj.length < that.tokenList.length) {
            let objKey = item.key
            if (objKey && that.tokenList.indexOf(objKey) !== -1) {
              that.tokenListObj.push(item)
              that.tokenObjErrValidate[objKey] = false
            }
          }
        })
      }
    },
    hasValidInputText() {
      let isInavlidForm = false
      let errKeyObj = Object.keys(this.tokenObjErrValidate)
      if (errKeyObj.length) {
        let inputObjLen = Object.keys(this.tokenObj).length
        if (inputObjLen) {
          errKeyObj.map(key => {
            if (
              inputObjLen &&
              (!this.tokenObj[key] || this.tokenObj[key] === '')
            ) {
              this.tokenObjErrValidate[key] = true
              isInavlidForm = true
            }
          })
        } else {
          errKeyObj.map(key => {
            this.tokenObjErrValidate[key] = true
            isInavlidForm = true
          })
        }
      }
      return isInavlidForm
    },
    constructSeperateObjForCustomFields() {
      let newObj = {
        customFields: {}
      }
      let tokenObj = Object.keys(this.tokenObj)
      if (tokenObj && tokenObj.length) {
        tokenObj.map(key => {
          if (key && key.toLowerCase().indexOf('customfield') !== -1) {
            newObj.customFields[key] = this.tokenObj[key]
          } else {
            if (key === 'mobileNumber') {
              newObj['mobilePhone'] = [this.tokenObj[key]]
            } else {
              newObj[key] = this.tokenObj[key]
            }
          }
        })
      }
      return newObj
    },
    addTokenAndScheduleSequence() {
      if (!this.hasValidInputText()) {
        this.$emit('scheduleSequenceWithToken', {
          seqId: this.seqId,
          tokenData: this.constructSeperateObjForCustomFields()
        })
      } else {
        shareFunction.showNotificationMsg(
          'Please add missing information and proceed',
          null
        )
      }
    },
    closePopup() {
      this.$emit('closeTokenPopup', false)
    },
    getPlaceHolderLabel(item) {
      if (
        item &&
        Object.keys(item).length &&
        item.key &&
        item.key.indexOf('customField') !== -1 &&
        this.customFields[item.key]
      ) {
        return this.customFields[item.key]
      } else {
        return item.text
      }
    }
  },
  created() {
    this.createInputTokenForm()
  }
}
</script>

<style scoped lang="scss">
.addTokenVariablePopup {
  position: fixed;
  @include flex-center;
  height: 100%;
  width: 100%;
  z-index: 5;
  top: 0;
  left: 0;
  right: 0;
  justify-content: center;
  .tokenVariableCard {
    @include relBlock;
    background: white;
    z-index: 5;
    border: 1px solid $c-eb;
    border-radius: 6px;
    width: calc(100% - 10%);
    box-shadow: 0 0 22.3px 1.7px rgba(59, 59, 59, 0.14);
    .tokenHeader {
      @include flex-center;
      justify-content: space-between;
      padding: 10px;
      background: #f3f9f3;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      .tokenTitle {
        color: $c-57;
        font-weight: 300;
        font-size: 14px;
        margin: 0;
        letter-spacing: 0.3px;
      }
      .closeTokenPopup {
        font-size: 16px;
        cursor: pointer;
      }
    }
    .tokenBody::v-deep {
      @include relBlock;
      padding: 15px;
      .inputTokenTitle {
        color: $c-57;
        font-size: 14px;
        margin: 0 0 10px;
        letter-spacing: 0.3px;
      }
      .tokenInputBody {
        position: relative;
        max-height: 360px;
        overflow: auto;
        margin-bottom: 10px;
        .tokenInputWrap {
          @include relBlock;
          .inputText {
            width: 90%;
            font-size: 14px;
            border: none;
            border-bottom: 1px solid $c-b0;
            color: $ae-blue;
            padding: 5px 0;
            margin-bottom: 20px;
            &::placeholder {
              color: rgba(87, 87, 92, 0.65);
            }
            &:focus {
              outline: none;
              transition: all 0.3s;
              border: none;
              border-bottom: 1px solid $ae-blue;
            }
          }
          .errMsg {
            position: absolute;
            display: block;
            color: red;
            font-size: 11px;
          }
        }
      }
      .tokenVariableSubmitBtn {
        @include relBlock;
        padding: 8px 20px;
        font-size: 14px;
        font-weight: bold;
        margin: 0 auto;
        border-radius: 35px;
      }
    }
  }
  .tokenVariableOverlay {
    background: rgb(0, 0, 0, 0.85);
    position: fixed;
    height: 100%;
    top: 0px;
    width: 100%;
    left: 0;
    z-index: 4;
  }
}
</style>
